<template>
  <div :class="$style.root">
    <el-form :model="form" label-width="auto" :class="$style.form" :rules="rules" ref="ruleFormRef">
      <h1 :class="$style.title">
        <p style="font-size: 32px; margin-bottom: 20px;">远程阅片系统</p>
        <p style="">欢迎登录</p>
      </h1>
      <el-form-item prop="loginId">
        <el-input v-model="form.loginId" size="large" placeholder="用户名" />
      </el-form-item>
      <div :class="$style.one_time_code_wrapper">
        <el-form-item :class="$style.one_time_code_input" prop="verifyCode">
          <el-input v-model="form.verifyCode" size="large" placeholder="验证码" />
        </el-form-item>
        <img :class="$style.code_img" :src="verifyCode" @click="getNewVerifyCode" />
      </div>
      <el-form-item prop="password">
        <el-input
          type="password"
          size="large"
          placeholder="密码"
          v-model="form.password"
          show-password
        />
      </el-form-item>
      <el-form-item>
        <el-checkbox
          size="large"
          label="记住密码"
          v-model="form.rememberPassword"
          @change="handleSavePassword"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          :class="$style.submit_button"
          type="primary"
          size="large"
          :loading="loading"
          @click="onSubmit(ruleFormRef)"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
  </div>

  <p :class="$style.copyright">@2023版权所有 苏州依视禾医疗科技有限公司</p>
</template>

<style module lang="scss">
@import './index.module.scss';
</style>

<script setup lang="ts">
import { reactive, ref, onMounted } from 'vue'
import { useAuthStore } from '@/stores'
import { saveProfile, generateToken } from '@/utils'
import type { FormInstance, FormRules } from 'element-plus'
import { ElMessage } from 'element-plus';
import { loginService, getVerifyCodeService } from '@/api'

interface RuleForm {
  loginId: string
  verifyCode: string
  password: string
  rememberPassword: boolean
}

const loading = ref(false)
const verifyCode = ref('')
const ruleFormRef = ref<FormInstance>()
const { login } = useAuthStore()

const secretKey = import.meta.env.VITE_SECRET_KEY

const form = reactive({
  loginId: '',
  verifyCode: '',
  password: '',
  rememberPassword: false
})

const rules = reactive<FormRules<RuleForm>>({
  loginId: [
    { required: true, message: '请输入用户名', trigger: 'change' },
    { min: 2, max: 15, message: '用户名长度在 3 到 15 个字符', trigger: 'blur' }
  ],
  verifyCode: [
    { required: true, message: '请输入验证码', trigger: 'change' },
    { min: 4, max: 4, message: '验证码为 4 位数字', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'change' },
  ]
})

// TODO: 表单回车进入下一行 / 提交

const getVerifyCode = async () => {
  const code = await getVerifyCodeService()
  return code
}

const getNewVerifyCode = async () => {
  const code = await getVerifyCode()
  // @ts-ignore
  const verifyCodeImgURL = URL.createObjectURL(code)

  verifyCode.value = verifyCodeImgURL
}

const handleRememberPassword = () => {
  const loginId = localStorage.getItem('loginId')
  const passwordCode = localStorage.getItem('password')

  if (loginId && passwordCode) {
    const password = atob(passwordCode)

    form.loginId = loginId
    form.password = password
    form.rememberPassword = true
  }
}

onMounted(async () => {
  getNewVerifyCode()
  handleRememberPassword()
})

const handleLogin = async () => {
  loading.value = true

  const { rememberPassword, ...data } = form

  try {
    const res = await loginService(data)

    if (res.code === '1000') {
      if (rememberPassword) {
        localStorage.setItem('loginId', data.loginId)
        localStorage.setItem('password', btoa(data.password))
      }

      const token = generateToken(res.data.user.sn, secretKey)

      login({ ...res.data, token })
      saveProfile(res.data.user)
    } else {
      ElMessage.error(res.msg)
      getNewVerifyCode()
    }

    loading.value = false
  } catch (e) {
    loading.value = false
  }
}

const onSubmit = async (formEl: FormInstance | undefined) => {
  if (!formEl) return

  await formEl.validate((valid) => {
    if (valid) {
      handleLogin()
    }
  })
}

const handleSavePassword = (value: boolean) => {
  form.rememberPassword = value
}
</script>

<style>
@media (min-width: 1024px) {
}
</style>
